import { App, GQL } from '@gin-betting/core';
import matchList from '@gin-betting/match-list';
import favorite from '@gin-betting/favorite';
import banners, { BannerTypes } from '@gin-betting/banners';
import { OrderedSet } from 'immutable';

import { Modules } from 'types';
import { AsyncMatchIdsGetter, MatchIdsGetter } from './types';

const {
    selectors: { selectCategoryByLocation },
} = matchList;

const {
    selectors: { selectFavoriteIds },
} = favorite;

const {
    selectors: { selectZoneBanners },
} = banners;

export const asyncMatchIdsHandler: AsyncMatchIdsGetter<'match'> = matchModule => state => {
    if (!matchModule) return OrderedSet<string>();

    const {
        selectors: { selectMatchId },
    } = matchModule;

    const matchId = selectMatchId(state);

    return OrderedSet<string>([matchId]);
};

export const makeIdsHandler = (route: App.Routes): MatchIdsGetter => {
    return state =>
        selectCategoryByLocation(state, { location: { pathname: route } })
            .matchIds;
};

export const favoritesIdsHandler: MatchIdsGetter = state =>
    selectFavoriteIds(state);

export const noopHandler: MatchIdsGetter = () => OrderedSet<string>();

export const makeIdsSelectorByRoute = (
    route: App.Routes,
    matchModule: Modules['match']['default'] | null
): MatchIdsGetter => {
    switch (route) {
        case App.Routes.UPCOMING_LIST:
        case App.Routes.OUTRIGHTS_LIST:
        case App.Routes.TOURNAMENT: {
            return makeIdsHandler(route);
        }

        case App.Routes.MATCH:
            return asyncMatchIdsHandler(matchModule);
        default:
            return noopHandler;
    }
};

export const bannerMatchIdsSelector: MatchIdsGetter = state => {
    const bannerMatchIds = selectZoneBanners(state as BannerTypes.State)
        .reduce(
            (bItems: BannerTypes.BannerItem[], banner) =>
                bItems.concat(banner.config),
            []
        )
        .filter(
            (
                banner: BannerTypes.BannerItem
            ): banner is BannerTypes.BannerSportEvent & { id: string } =>
                !!banner.id &&
                banner.type === GQL.BannerType.betting_sport_event
        )
        .map(({ id }) => id);

    return OrderedSet(bannerMatchIds);
};
